// FleetOS — Fælles tema-system 2026
// CSS custom properties sættes på :root — alle komponenter bruger var(--...)

export const themes = {
  'dark-pro': {
    name: 'Dark Pro',
    icon: '🌑',
    dark: true,
    vars: {
      '--bg': '#0a0a0f',
      '--bg-2': '#111118',
      '--bg-3': '#1a1a24',
      '--bg-4': '#22222f',
      '--border': '#2a2a3a',
      '--border-light': '#1e1e2a',
      '--text': '#f0f0ff',
      '--text-2': '#a0a0c0',
      '--text-3': '#606080',
      '--accent': '#6366f1',
      '--accent-2': '#818cf8',
      '--accent-bg': '#6366f115',
      '--green': '#22c55e',
      '--green-bg': '#22c55e15',
      '--red': '#ef4444',
      '--red-bg': '#ef444415',
      '--orange': '#f59e0b',
      '--orange-bg': '#f59e0b15',
      '--shadow': '0 4px 24px rgba(0,0,0,0.4)',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.3)',
      '--radius': '10px',
      '--radius-sm': '6px',
      '--radius-lg': '16px',
    }
  },
  'light-clean': {
    name: 'Light Clean',
    icon: '☀️',
    dark: false,
    vars: {
      '--bg': '#ffffff',
      '--bg-2': '#f8fafc',
      '--bg-3': '#f1f5f9',
      '--bg-4': '#e2e8f0',
      '--border': '#e2e8f0',
      '--border-light': '#f1f5f9',
      '--text': '#0f172a',
      '--text-2': '#475569',
      '--text-3': '#94a3b8',
      '--accent': '#2563eb',
      '--accent-2': '#3b82f6',
      '--accent-bg': '#2563eb10',
      '--green': '#16a34a',
      '--green-bg': '#16a34a10',
      '--red': '#dc2626',
      '--red-bg': '#dc262610',
      '--orange': '#d97706',
      '--orange-bg': '#d9770610',
      '--shadow': '0 4px 16px rgba(0,0,0,0.06)',
      '--shadow-sm': '0 1px 3px rgba(0,0,0,0.05)',
      '--radius': '10px',
      '--radius-sm': '6px',
      '--radius-lg': '16px',
    }
  },
  'ocean-blue': {
    name: 'Ocean Blue',
    icon: '🌊',
    dark: true,
    vars: {
      '--bg': '#030712',
      '--bg-2': '#0c1628',
      '--bg-3': '#0f1e38',
      '--bg-4': '#162544',
      '--border': '#1e3a5f',
      '--border-light': '#152d4a',
      '--text': '#e0f2fe',
      '--text-2': '#7dd3fc',
      '--text-3': '#38bdf8',
      '--accent': '#0ea5e9',
      '--accent-2': '#38bdf8',
      '--accent-bg': '#0ea5e920',
      '--green': '#34d399',
      '--green-bg': '#34d39920',
      '--red': '#f87171',
      '--red-bg': '#f8717120',
      '--orange': '#fbbf24',
      '--orange-bg': '#fbbf2420',
      '--shadow': '0 4px 24px rgba(0,0,0,0.5)',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.4)',
      '--radius': '10px',
      '--radius-sm': '6px',
      '--radius-lg': '16px',
    }
  },
  'forest': {
    name: 'Forest',
    icon: '🌿',
    dark: true,
    vars: {
      '--bg': '#050f08',
      '--bg-2': '#0a1a0f',
      '--bg-3': '#0f2318',
      '--bg-4': '#162d1e',
      '--border': '#1e4028',
      '--border-light': '#162d1e',
      '--text': '#ecfdf5',
      '--text-2': '#86efac',
      '--text-3': '#4ade80',
      '--accent': '#22c55e',
      '--accent-2': '#4ade80',
      '--accent-bg': '#22c55e20',
      '--green': '#22c55e',
      '--green-bg': '#22c55e20',
      '--red': '#f87171',
      '--red-bg': '#f8717120',
      '--orange': '#fbbf24',
      '--orange-bg': '#fbbf2420',
      '--shadow': '0 4px 24px rgba(0,0,0,0.5)',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.3)',
      '--radius': '10px',
      '--radius-sm': '6px',
      '--radius-lg': '16px',
    }
  },
  'electric': {
    name: 'Electric',
    icon: '⚡',
    dark: true,
    vars: {
      '--bg': '#08050f',
      '--bg-2': '#110a1e',
      '--bg-3': '#180f2a',
      '--bg-4': '#201535',
      '--border': '#3b1f6a',
      '--border-light': '#2a1550',
      '--text': '#faf5ff',
      '--text-2': '#c4b5fd',
      '--text-3': '#a78bfa',
      '--accent': '#8b5cf6',
      '--accent-2': '#a78bfa',
      '--accent-bg': '#8b5cf620',
      '--green': '#34d399',
      '--green-bg': '#34d39920',
      '--red': '#f87171',
      '--red-bg': '#f8717120',
      '--orange': '#fbbf24',
      '--orange-bg': '#fbbf2420',
      '--shadow': '0 4px 24px rgba(139,92,246,0.2)',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.4)',
      '--radius': '10px',
      '--radius-sm': '6px',
      '--radius-lg': '16px',
    }
  }
};

export const layouts = {
  sidebar: { name: 'Sidebar', icon: '▐' },
  topbar: { name: 'Topbar', icon: '▀' },
  compact: { name: 'Kompakt', icon: '☰' },
};

export const fontSizes = {
  small: { name: 'Lille', base: '13px' },
  normal: { name: 'Normal', base: '14px' },
  large: { name: 'Stor', base: '16px' },
};

export function applyTheme(themeKey) {
  const theme = themes[themeKey] || themes['dark-pro'];
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  root.setAttribute('data-theme', themeKey);
  root.setAttribute('data-dark', theme.dark ? '1' : '0');
}

export function applyFontSize(sizeKey) {
  const size = fontSizes[sizeKey] || fontSizes['normal'];
  document.documentElement.style.setProperty('--font-base', size.base);
}

export function loadUserTheme() {
  const theme = localStorage.getItem('fleetos_theme') || 'light-clean';
  const fontSize = localStorage.getItem('fleetos_fontsize') || 'normal';
  applyTheme(theme);
  applyFontSize(fontSize);
  return { theme, fontSize };
}

export function saveUserTheme(themeKey, fontSizeKey) {
  localStorage.setItem('fleetos_theme', themeKey);
  if (fontSizeKey) localStorage.setItem('fleetos_fontsize', fontSizeKey);
  applyTheme(themeKey);
  if (fontSizeKey) applyFontSize(fontSizeKey);
}
